import Vue from 'vue';
import VueRouter from 'vue-router';

import { getToken } from '@/utils/auth';
import { BIND_PHONE_PENDING_KEY } from '@/utils/bindPhone';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录', guest: true }
  },
  {
    path: '/',
    component: () => import('@/views/layout/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/home'
      },
      /* 首页 */
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/home/DataSummary.vue'),
        meta: { title: '首页', requiresAuth: true }
      },
      /* 课程管理 — 社团课 / 校本课 */
      {
        path: 'courses/club',
        name: 'ClubCourses',
        component: () => import('@/views/courses/ClubCourses.vue'),
        meta: { title: '社团课', requiresAuth: true }
      },
      {
        path: 'courses/club/:id',
        name: 'ClubCourseDetail',
        component: () => import('@/views/courses/ClubCourseDetail.vue'),
        meta: { title: '课程详情', requiresAuth: true }
      },
      {
        path: 'courses/school-publish/new',
        name: 'SchoolCoursePublishNew',
        component: () => import('@/views/school/SchoolCoursePublishForm.vue'),
        meta: { title: '新建校本课', requiresAuth: true }
      },
      {
        path: 'courses/school-publish/:id/edit',
        name: 'SchoolCoursePublishEdit',
        component: () => import('@/views/school/SchoolCoursePublishForm.vue'),
        meta: { title: '编辑校本课', requiresAuth: true }
      },
      {
        path: 'courses/school-publish/:id',
        name: 'SchoolCoursePublishDetail',
        component: () => import('@/views/school/SchoolCoursePublishDetail.vue'),
        meta: { title: '校本课详情', requiresAuth: true }
      },
      {
        path: 'courses/school-publish',
        name: 'SchoolCoursePublishList',
        component: () => import('@/views/school/SchoolCoursePublishList.vue'),
        meta: { title: '校本课', requiresAuth: true }
      },
      {
        path: 'courses/school',
        name: 'SchoolCoachResources',
        component: () => import('@/views/school/SchoolCoachResources.vue'),
        meta: { title: '师资库', requiresAuth: true }
      },
      {
        path: 'courses/school/:id',
        name: 'SchoolCoachDetail',
        component: () => import('@/views/school/SchoolCoachDetail.vue'),
        meta: { title: '教练详情', requiresAuth: true }
      },
      /* 课程管理 — 送教课 */
      {
        path: 'courses/teaching-delivery/applies/:id',
        name: 'TeachingDeliveryApplyDetail',
        component: () => import('@/views/courses/TeachingDeliveryApplyDetail.vue'),
        meta: { title: '送教申请详情', requiresAuth: true }
      },
      {
        path: 'courses/teaching-delivery/applies',
        name: 'TeachingDeliveryApplyList',
        component: () => import('@/views/courses/TeachingDeliveryApplyList.vue'),
        meta: { title: '我的送教申请', requiresAuth: true }
      },
      {
        path: 'courses/teaching-delivery/:id/apply',
        name: 'TeachingDeliveryApplyForm',
        component: () => import('@/views/courses/TeachingDeliveryApplyForm.vue'),
        meta: { title: '提交送教申请', requiresAuth: true }
      },
      {
        path: 'courses/teaching-delivery/:id',
        name: 'TeachingDeliveryCourseDetail',
        component: () => import('@/views/courses/TeachingDeliveryCourseDetail.vue'),
        meta: { title: '送教课详情', requiresAuth: true }
      },
      {
        path: 'courses/teaching-delivery',
        name: 'TeachingDeliveryCourses',
        component: () => import('@/views/courses/TeachingDeliveryCourses.vue'),
        meta: { title: '送教课', requiresAuth: true }
      },
      /* 课程日历 */
      {
        path: 'calendar',
        name: 'CourseCalendar',
        component: () => import('@/views/calendar/CourseCalendar.vue'),
        meta: { title: '课程日历', requiresAuth: true }
      },
      {
        path: 'calendar/session/:id',
        redirect: (to) => ({ name: 'CourseCalendar', query: { session: to.params.id } })
      },
      /* 消息 */
      {
        path: 'messages',
        name: 'Messages',
        component: () => import('@/views/messages/MessagesPage.vue'),
        meta: { title: '消息', requiresAuth: true }
      },
      /* 全部订单 */
      {
        path: 'orders',
        name: 'AllOrders',
        component: () => import('@/views/orders/AllOrders.vue'),
        meta: { title: '全部订单', requiresAuth: true }
      },
      /* 成绩管理 */
      {
        path: 'scores/fitness',
        name: 'FitnessScoreImport',
        component: () => import('@/views/scores/FitnessScoreImport.vue'),
        meta: { title: '体测成绩上传', requiresAuth: true }
      },
      {
        path: 'scores/pe-exam',
        name: 'PeExamScoreImport',
        component: () => import('@/views/scores/PeExamScoreImport.vue'),
        meta: { title: '体育课成绩上传', requiresAuth: true }
      },
      { path: 'scores', redirect: '/scores/fitness' },
      /* 我的 */
      {
        path: 'mine/data-board',
        name: 'DataBoard',
        component: () => import('@/views/board/DataBoard.vue'),
        meta: { title: '数据看板', requiresAuth: true }
      },
      {
        path: 'mine/users',
        name: 'UserManagement',
        component: () => import('@/views/users/UserManagement.vue'),
        meta: { title: '用户管理', requiresAuth: true }
      },
      {
        path: 'mine/grades',
        name: 'GradeManagement',
        component: () => import('@/views/users/GradeManagement.vue'),
        meta: { title: '年级管理', requiresAuth: true }
      },
      {
        path: 'mine/settings',
        name: 'SystemSettings',
        component: () => import('@/views/settings/SystemSettings.vue'),
        meta: { title: '系统设置', requiresAuth: true }
      },
      {
        path: 'mine/profile',
        name: 'MyProfile',
        component: () => import('@/views/profile/MyProfile.vue'),
        meta: { title: '我的资料', requiresAuth: true }
      },
      {
        path: 'mine/support',
        name: 'CustomerSupport',
        component: () => import('@/views/support/CustomerSupport.vue'),
        meta: { title: '联系客服', requiresAuth: true }
      },
      /* 旧路径兼容（书签与外链） */
      { path: 'data-summary', redirect: '/home' },
      { path: 'home-plugin-test', redirect: '/home' },
      { path: 'club-courses', redirect: '/courses/club' },
      {
        path: 'club-courses/:id',
        redirect: (to) => ({ path: `/courses/club/${to.params.id}` })
      },
      { path: 'school-courses', redirect: '/courses/school' },
      {
        path: 'school-courses/:id',
        redirect: (to) => ({ path: `/courses/school/${to.params.id}` })
      },
      { path: 'course-calendar', redirect: '/calendar' },
      {
        path: 'course-calendar/session/:id',
        redirect: (to) => ({ name: 'CourseCalendar', query: { session: to.params.id } })
      },
      { path: 'data-board', redirect: '/mine/data-board' },
      { path: 'users', redirect: '/mine/users' },
      { path: 'grades', redirect: '/mine/grades' },
      { path: 'my-profile', redirect: '/mine/profile' }
    ]
  },
  {
    path: '*',
    redirect: '/home'
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = `${title} · ${process.env.VUE_APP_TITLE || ''}`;
  }

  const isGuestRoute = to.matched.some((r) => r.meta && r.meta.guest);
  const token = getToken();

  if (!isGuestRoute && !token) {
    next({ path: '/login', query: { redirect: to.fullPath } });
    return;
  }

  if (to.path === '/login' && token) {
    try {
      if (sessionStorage.getItem(BIND_PHONE_PENDING_KEY) === '1') {
        next();
        return;
      }
    } catch {
      /* ignore */
    }
    const redirect = to.query.redirect;
    if (
      redirect &&
      typeof redirect === 'string' &&
      redirect !== '/login' &&
      !redirect.startsWith('/login')
    ) {
      next(redirect);
    } else {
      next({ path: '/home' });
    }
    return;
  }

  next();
});

export default router;
